module.exports = __webpack_public_path__ + "img/kommune-1222.9f18b236.svg";